module.exports = __webpack_public_path__ + "static/media/moneytransfersinsha.e55e60a5.png";